var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 18.75V19.7917C21.875 20.9375 20.9375 21.875 19.7917 21.875H5.20833C4.05208 21.875 3.125 20.9375 3.125 19.7917V5.20833C3.125 4.0625 4.05208 3.125 5.20833 3.125H19.7917C20.9375 3.125 21.875 4.0625 21.875 5.20833V6.25H12.5C11.3438 6.25 10.4167 7.1875 10.4167 8.33333V16.6667C10.4167 17.8125 11.3438 18.75 12.5 18.75H21.875ZM12.5 16.6667H22.9167V8.33333H12.5V16.6667ZM16.6667 14.0625C15.8021 14.0625 15.1042 13.3646 15.1042 12.5C15.1042 11.6354 15.8021 10.9375 16.6667 10.9375C17.5313 10.9375 18.2292 11.6354 18.2292 12.5C18.2292 13.3646 17.5313 14.0625 16.6667 14.0625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon1);
export default __webpack_public_path__ + "static/media/wallet-icon-1.d757ac279218d80a368709aceb068dca.svg";
export { ForwardRef as ReactComponent };